import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Grid, Button, Typography } from '@mui/material';
import CircularLoader from 'Components/Loaders/CircularLoader';
import useGlobalState from 'Hooks/useGlobalState';
import mainStyles from 'Styles/mainStyles';
import { useTranslation } from 'react-i18next';


const ConfirmInstalled = (props) => {
	const [state] = useGlobalState();
	const navigate = useNavigate();
	const location = useLocation();
	const classes = mainStyles();
	const { t } = useTranslation();

	useEffect(() => {
		console.log('ConfirmInstalled - useEffect')
		// const fetchData = async () => {
		// 	let device = await getDeviceByUuname('skyen'+deviceId)
		// 	dispatch({ device: device });
		// }
		// fetchData();
		console.log(state.device, location)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	const handleConfirm = () => {
		navigate('../building')
	}
	return (state.device ? 
		<Container component="main" maxWidth="sm">
			<Grid container justifyContent={'center'} alignItems='center'>
				<div className={classes.onboardContainer}>
					<Typography variant="h4" className={classes.title}>{t('Er sensoren korrekt installeret?')}</Typography>
				</div>
				<div className={classes.onboardImageContainer}>
					<img src="/assets/install.png" alt="Installation" className={classes.onboardImageSkyen} />
				</div>
				<div className={classes.onboardContainer}>
					<Typography variant="body2" className={classes.title}>{t('Vi anbefaler at sensoren er fast installeret på den ønskede placering før du gennemgår opsætningsflowet. Bekræft at sensoren er korrekt opsat på den ønskede lokation. ')}</Typography>
				</div>

				<Button onClick={handleConfirm} variant="contained" className={classes.greenButton}>{t('Sensoren er sat op')}</Button>
			</Grid>
		</Container>
		:
		<CircularLoader />
	)

}

export default ConfirmInstalled;